// Accept editable prefixes, not arbitrary text. Final minutes/step validation
// remains in parseMonthCell; e.g. `8,` must be possible while typing `8,25`.
function isTimesheetValuePrefix(value, codes = [], maximumMinutes = 1440) {
    const text = String(value || '').replace(/,/g, '.').replace(/\//g, ' ').toLocaleUpperCase('ru-RU');
    const tokens = text.trim().split(/\s+/).filter(Boolean);
    if (!tokens.length) return true;
    if (tokens.length > 3) return false;
    let states = [{hours: null, categories: [], standalone: false}];
    tokens.forEach((token, index) => {
        const next = [];
        if (/^\d+(\.\d*)?$/.test(token)) {
            const hours = Number(token);
            if (Number.isFinite(hours) && hours >= 0 && hours * 60 <= maximumMinutes) {
                states.forEach(state => {
                    if (state.hours === null && !(hours > 0 && state.standalone)) next.push({...state, hours});
                });
            }
        } else {
            const partial = index === tokens.length - 1 && !/\s$/.test(text);
            codes.forEach(code => {
                const name = String(code.code || '').toLocaleUpperCase('ru-RU');
                if (!name || name === 'ДТ' || !(partial ? name.startsWith(token) : name === token)) return;
                const category = code.category === 'travel' ? 'travel' : 'absence';
                const standalone = code.can_combine_with_work === false || name === 'Л';
                states.forEach(state => {
                    if (state.categories.includes(category) || (state.hours > 0 && standalone)) return;
                    next.push({...state, categories: [...state.categories, category], standalone: state.standalone || standalone});
                });
            });
        }
        states = next;
    });
    return states.length > 0;
}

module.exports = {isTimesheetValuePrefix};
